import { FC, PropsWithChildren, useEffect } from 'react'
import { Link } from 'react-router-dom'
// import broadcastIcon from '../../assets/icons/broadcast.svg'
import NotificationIcon from '../../assets/icons/notification'
import profileIcon from '../../assets/icons/profile-icon.svg'
import useAuth from '../../hooks/useAuth'
import getUserFirstName from '../../utils/getUserFirstName'
import VerifyEmailBanner from '../VerifyEmailBanner'
import useRefreshEstateAccess from '../../hooks/useRefreshEstateAccess'

type PageWrapperProps = PropsWithChildren<{
  title: string
  description?: string
}>

const PageWrapper: FC<PageWrapperProps> = ({ title, description, children }) => {
  const refreshAccess = useRefreshEstateAccess()
  const { user } = useAuth()
  const SHOW_NOTIFICATION_ICON = false
  useEffect(() => {
    refreshAccess()
  }, [refreshAccess])

  return (
    <main className="py-4 sm:px-10 pt-10 max-w-full px-5">
      {user && <VerifyEmailBanner />}
      <div className="flex flex-wrap items-center justify-between gap-4 mb-14">
        <div>
          <h1 className="text-2xl font-medium leading-normal text-black">{title}</h1>
          {description && (
            <p className="mt-1 text-base leading-none text-gray-600">{description}</p>
          )}
        </div>
        <div className="flex items-center space-x-3" />
        <div className="flex space-x-10 items-center">
          {
            SHOW_NOTIFICATION_ICON && (
              <div>
                <NotificationIcon hasNotification={false} />
              </div>
            )
          }

          {/* <Link to="/broadcast">
            <div className="flex items-center text-[16px] p-2.5 rounded-[10px] bg-gray-900 space-x-2.5 text-gray-100 cursor-pointer text-bold font-medium flex-wrap">
              <img src={broadcastIcon} alt="broadcast" className="w-7" />
              <p>Broadcast</p>
            </div>
          </Link> */}
          <Link to="/settings/profile">
            <div className="flex overflow-ellipsis items-center text-[16px] p-2.5 rounded-[8px] bg-gray-100 space-x-2.5 cursor-pointer font-medium  flex-wrap">
              <img
                src={user.imageUrl || profileIcon}
                alt="profile"
                className="bg-gray-100 rounded-[8px] w-6 h-6 object-cover"
              />
              <p>{getUserFirstName(user.name)}'s profile</p>
            </div>
          </Link>
        </div>
      </div>
      {children}
    </main>
  )
}

export default PageWrapper
